import { message } from 'antd';
import { client } from '../../../actions';
import { userActions } from '../../../actions/user.actions';
import { authHeader } from '../../../helpers/auth-header';
import store from '../../../store';

const editRoom = async (formValues) => {
  try {
    const response = await client.put(
      '/RentPlace/rental_house/office',
      formValues,
      {
        headers: authHeader(),
      }
    );

    return response;
  } catch (error) {
    if (error.response?.status === 401) {
      store.dispatch(userActions.logout());
      return;
    }
    console.error(error);
    message.error('При редактировании помещения произошла ошибка');
  }
};

export default editRoom;
